import React, { useContext, useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  TextField,
  InputAdornment,
  IconButton,
  Snackbar,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { CopyToClipboard } from "react-copy-to-clipboard";
import FileCopyRoundedIcon from "@material-ui/icons/FileCopyRounded";

// Contexts
import CampaignContext from "../../../context/campaign/CampaignContext";

const useStyles = makeStyles(() => ({
  button: {
    "&:focus": {
      outline: "none",
    },
  },
  snackbar: {
    marginTop: "3rem",
  },
}));

const Section_00 = () => {
  const classes = useStyles();

  const { selected_campaign, agency_account } = useContext(CampaignContext);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [campaign_url, setCampaignUrl] = useState("");
  const [campaign_url_test, setCampaignUrlTest] = useState("");

  const copyButton = (link) => (
    <InputAdornment position="end">
      <CopyToClipboard text={link}>
        <IconButton
          className={classes.button}
          edge="end"
          disabled={link ? false : true}
          onClick={() => setOpenSnackbar(true)}
        >
          <FileCopyRoundedIcon size="small" />
        </IconButton>
      </CopyToClipboard>
    </InputAdornment>
  );

  useEffect(() => {
    if (selected_campaign) {
      const { domain, campaign_id } = selected_campaign;

      if (domain && campaign_id) {
        if (agency_account) {
          setCampaignUrl(`https://${domain}/products/${campaign_id}`);
          setCampaignUrlTest(
            `https://${domain}/products/${campaign_id}/?test=true`
          );
        } else {
          setCampaignUrl(`https://${domain}/pages/${campaign_id}`);
          setCampaignUrlTest(
            `https://${domain}/pages/${campaign_id}/?test=true`
          );
        }
      }
    }
  }, [selected_campaign, agency_account]);

  return (
    <Grid container spacing={1}>
      <Snackbar
        className={classes.snackbar}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        open={openSnackbar}
        autoHideDuration={2000}
        onClose={() => setOpenSnackbar(false)}
      >
        <Alert severity="info"> Copied! </Alert>
      </Snackbar>
      <Grid item xs={6}>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          margin="dense"
          label="Campaign URL"
          id="campaign_url"
          name="campaign_url"
          value={campaign_url}
          InputProps={{
            readOnly: true,
            endAdornment: copyButton(campaign_url),
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          margin="dense"
          label="Campaign Test URL"
          id="campaign_url_test"
          name="campaign_url_test"
          value={campaign_url_test}
          InputProps={{
            readOnly: true,
            endAdornment: copyButton(campaign_url_test),
          }}
        />
      </Grid>
    </Grid>
  );
};

export default Section_00;
